/**
 * Hide any `img` that fails to load, so a failed image degrades to empty space instead of the
 * renderer's broken-image glyph.
 *
 * This is a safety net, not a mechanism: content that genuinely needs a fallback should preload
 * and swap (see helpers/img.js `preloadImage` and the ProgressiveImage component) rather than rely
 * on this. What it guarantees is that an image path nobody anticipated — a 404 attachment, an
 * offline fetch in the native apps — can never paint a broken glyph.
 *
 * Capture phase is required: image load/error events do not bubble, so a listener on `document`
 * only sees them on the way down.
 *
 * Call once from each bundle entry.
 */
export function hideFailedImages(providedDocument = document) {
    providedDocument.addEventListener('error', (event) => {
        const element = event.target;
        if (!element || element.tagName !== 'IMG') return;

        // An img with no src isn't a failure — it's an element waiting to be given one (which is
        // exactly how ProgressiveImage's full-res image starts life).
        if (!element.getAttribute('src')) return;

        element.classList.add('img--failed');
    }, true);
}
